import Footer from '../Footer.jsx'
import SedricaCard from './SedricaTeam.jsx'
import MyClass from '../Nav.jsx'
import Statistics from './Statistics.jsx'
import Aboutus from './Aboutus.jsx'
import SedHero from './SedHero.jsx'

function Sedrica(){
    return (
        <>
            <MyClass/>
            <SedHero/>
            <Aboutus/>
            <Statistics/>
            
            {/* Removed the <hr/> so the gradient blends perfectly */}
            
            {/* Swapped backgroundColor for a linear-gradient */}
            <div style={{ 
                background: "linear-gradient(to bottom, #000000, #1a1a1a)" 
            }}>
                
                {/* Added pt-5 so the gradient has space to fade before the text starts */}
                <div className="pt-5"> 
                    <SedricaCard/>
                </div>
                
                <Footer/>
            </div>
        </>
    )
}

export default Sedrica